import { useForm } from "react-hook-form";
import GlobalBackground from "../../components/GlobalBackground/GlobalBackground";
import FormInputs from "../../components/FormInputs/FormInputs";
import { useEffect, useState } from "react";
import { handleCopyPaste } from "../../utils/PreventDefault/PreventDefault";
import "./EmailVerification.css";
import {
  showErrorToast,
  showSuccessToast,
} from "../../utils/ToastMessages/ToastMessages";
import { resetPassword } from "../../api/apiServices";
import { useNavigate, useParams } from 'react-router-dom';

const EmailVerification = () => {
  const {
    register,
    handleSubmit,
    formState: { errors: errors },
  }: any = useForm();
  const [showPassword, setShowPassword] = useState(false);
  const [showConfirmPassword, setShowConfirmPassword] = useState(false);
  const { uuid, token } = useParams();
  const navigate = useNavigate();

  const passwordVisibilityHandler = () => {
    setShowPassword(!showPassword);
  };

  const confirmPasswordVisibilityHandler = () => {
    setShowConfirmPassword(!showConfirmPassword);
  };

  const verifyOtp = async (data: any) => {
    try {
      const bodyObject = {
        new_password: data.password,
      };

      if (data.password === data.reenterPassword) {
        const otpHandle: any = await resetPassword(bodyObject, uuid, token);
        console.log("otpHandle-------->>>", otpHandle);
        if (!!otpHandle) {
          showSuccessToast(otpHandle.message);
          navigate('/');
        } else {
          showErrorToast("Please Enter Valid Password!");
        }
      } else {
        showErrorToast("Enter Same Password and Re-entered Password!");
      }
    } catch (error: any) {
      showErrorToast(
        error?.response?.data?.error || "Please Enter Valid Password!"
      );
    }
  };

  return (
    <GlobalBackground>
      <div className="otp-outer-container">
        <div className="otp-form-container">
          <form onSubmit={handleSubmit(verifyOtp)}>
            {/* Password */}
            <div className="otp-password-container">
              <FormInputs
                maxLength={15}
                type={showPassword ? "default" : "password"}
                register={register}
                placeholder={"Enter Password"}
                name={"password"}
                required={"Password is required"}
                pattern={
                  /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[@$!%*?&#])[A-Za-z\d@$!%*?&#]{8,15}$/
                }
                message={
                  "Password must be 8-15 characters long and include at least one uppercase letter, one lowercase letter, one number, and one special character."
                }
                errors={errors}
                prevent={handleCopyPaste}
                disabled={false}
              />
              <div
                onClick={passwordVisibilityHandler}
                className="otp-password-visibility"
              >
                {showPassword ? (
                  <img alt="eye" src={require("../../assets/images/eye.png")} />
                ) : (
                  <img
                    alt="closed-eye"
                    src={require("../../assets/images/hidden.png")}
                  />
                )}
              </div>
            </div>

            {/* confirm password */}

            <div className="otp-password-container">
              <FormInputs
                maxLength={15}
                type={showConfirmPassword ? "default" : "password"}
                register={register}
                placeholder={"Confirm Password"}
                name={"reenterPassword"}
                required={"Reenter your password"}
                pattern={
                  /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[@$!%*?&#])[A-Za-z\d@$!%*?&#]{8,15}$/
                }
                message={
                  "The passwords you entered don’t match. Please check and try again."
                }
                errors={errors}
                prevent={handleCopyPaste}
                disabled={false}
              />
              <div
                onClick={confirmPasswordVisibilityHandler}
                className="otp-password-visibility"
              >
                {showConfirmPassword ? (
                  <img alt="eye" src={require("../../assets/images/eye.png")} />
                ) : (
                  <img
                    alt="closed-eye"
                    src={require("../../assets/images/hidden.png")}
                  />
                )}
              </div>
            </div>

            <div className="otp-button">
              <button type="submit">Reset Password</button>
            </div>
          </form>
        </div>
      </div>
    </GlobalBackground>
  );
};

export default EmailVerification;
